import { Box, Stack, Typography, useTheme } from "@mui/material";
import { desiredIntegrationsList } from "../data";
import { IntegrationItem } from "./IntegrationItem";
import { useContext } from "react";
import { FeedbackContext } from "../context";
import { OtherCustomInput } from "./OtherCustomInput";

export const SelectDesiredIntegrations = () => {
  const theme = useTheme();
  const context = useContext(FeedbackContext);
  if (!context) throw new Error("wrong context provided");
  const { desiredIntegrations, toggleIntegration, toggleOtherIntegration } =
    context;
  const isOtherSelected = desiredIntegrations.some((item) =>
    item.value.startsWith("other_"),
  );
  return (
    <Stack gap="16px">
      <Typography variant="body-medium" color={theme.palette.lightBg.low}>
        Would you consider mentioning the integration you were looking for?
      </Typography>
      <Box display="grid" gridTemplateColumns={"repeat(2, 1fr)"} gap="12px">
        {desiredIntegrationsList.map((integration) => {
          const isChecked = desiredIntegrations.some(
            (item) => item.value === integration.value,
          );
          return (
            <IntegrationItem
              key={integration.value}
              label={integration.label}
              logo={integration.logo}
              isChecked={isChecked}
              onClick={() =>
                toggleIntegration({
                  label: integration.label,
                  value: integration.value,
                })
              }
            />
          );
        })}
        <OtherCustomInput
          isSelected={isOtherSelected}
          onClick={toggleOtherIntegration}
          sx={{
            gridColumn: "1/-1",
          }}
          placeholder="Tell us which integrations you need"
        />
      </Box>
    </Stack>
  );
};
